<template>
	<div>
		<a-page-header style="background: #fff;" title="广告管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'广告管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加广告
				</a-button>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="pic" slot-scope="pic">
						<img :src="pic" style="width: 25rem"></img>
					</span>
					<span slot="type" slot-scope="type">
						<a-tag color="blue">{{type}}</a-tag>
					</span>
					<span slot="isShow" slot-scope="isShow">
						<a-tag color="green" v-if="isShow == 1">显示</a-tag>
						<a-tag color="orange" v-if="isShow == 0">隐藏</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="getView(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加广告弹出 -->
		<a-modal title="添加广告" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="60%">
			<a-form-model ref="addForm" :model="addForm" :rules="addFormRules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="广告类型" prop="type">
					<a-radio-group v-model="addForm.type" button-style="solid">
						<a-radio-button :value="1">
							首页广告
						</a-radio-button>
						<!-- <a-radio-button :value="2">
							同城信息页广告
						</a-radio-button>
						<a-radio-button :value="3">
							积分商城页广告
						</a-radio-button> -->
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="广告图">
					<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 @change="photoChange">
						<img v-if="addForm.pic" :src="addForm.pic" alt="avatar" style=" width: 44.375rem;height: 21.875rem;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">广告图</div>
						</div>
					</a-upload>
					<div style="color: #ffc53d;">图片尺寸为 710px * 350px</div>
				</a-form-model-item>
				<a-form-model-item label="排序">
					<a-input v-model="addForm.order" style="width: 300px;"></a-input>
					<div style="color: #ffc53d;">数值越大排名越靠前 例如 100 > 99</div>
				</a-form-model-item>
				<a-form-model-item label="是否显示">
					<a-switch checked-children="显示" un-checked-children="隐藏" v-model="addForm.isShow" default-checked />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 查看广告弹出 -->
		<a-modal title="修改广告" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="保存" width="60%">
			<a-form-model ref="editForm" :model="editForm" :rules="addFormRules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="广告类型" prop="type">
					<a-radio-group v-model="editForm.type" button-style="solid">
					<a-radio-button :value="1">
						首页广告
					</a-radio-button>
					<!-- <a-radio-button :value="2">
						同城信息页广告
					</a-radio-button>
					<a-radio-button :value="3">
						积分商城页广告
					</a-radio-button> -->
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="广告图">
					<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 @change="editPhotoChange">
						<img v-if="editForm.pic" :src="editForm.pic" alt="avatar" style="width: 25rem;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">广告图</div>
						</div>
					</a-upload>
					<div style="color: #ffc53d;">图片尺寸为 710px * 350px</div>
				</a-form-model-item>
				<a-form-model-item label="排序">
					<a-input v-model="editForm.order"></a-input>
					<div style="color: #ffc53d;">数值越大排名越靠前 例如 100 > 99</div>
				</a-form-model-item>
				<a-form-model-item label="是否显示">
					<a-switch checked-children="显示" un-checked-children="隐藏" v-model="editForm.isShow" default-checked />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '广告图',
			dataIndex: 'pic',
			scopedSlots: {
				customRender: 'pic'
			},
		},
		{
			title: '广告类型',
			dataIndex: 'type',
			scopedSlots: {
				customRender: 'type'
			},
		},
		{
			title: '排序',
			dataIndex: 'order',
		},
		{
			title: '是否显示',
			dataIndex: 'isShow',
			scopedSlots: {
				customRender: 'isShow'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addtime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				list: [],
				info: '',
				columns,
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 14
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {
          type: 1
        },
				addModal: false,
				editForm: {},
				editModal: false,
				loading: false,
				advId:'',
				addFormRules: {
					type: [{
						required: true,
						message: '请选择广告类型',
						trigger: 'change'
					}],
					linkType: [{
						required: true,
						message: '请选择跳转页面',
						trigger: 'change'
					}],
					linkUrl: [{
						required: true,
						message: '请选择页面地址',
						trigger: 'change'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			photoChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.addForm.pic = info.file.response.url;
					this.loading = false;
				}
			},

			editPhotoChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.editForm.pic = info.file.response.url;
					this.loading = false;
				}
			},

			toDetail(id) {
				this.$router.push('/anchor/anchorDetail?id=' + id)
			},

			getView(id) {
				this.advId = id
				this.$http.post('/admin/index.php/admin/advert/advertInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			editSubmit() {
				this.$http.post('/admin/index.php/admin/advert/advertSave', {
					id:this.advId,
					type: this.editForm.type,
					pic: this.editForm.pic,
					linkType: this.editForm.linkType,
					linkUrl: this.editForm.linkUrl,
					order: this.editForm.order,
					isShow: this.editForm.isShow,
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success('修改成功！');
						this.editModal = false
						this.getList()
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			addSubmit() {
				this.$http.post('/admin/index.php/admin/advert/advertSave', {
					type: this.addForm.type,
					pic: this.addForm.pic,
					linkType: this.addForm.linkType,
					linkUrl: this.addForm.linkUrl,
					order: this.addForm.order,
					isShow: this.addForm.isShow,
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success('添加成功！');
						this.addModal = false
						this.getList()
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/advert/advertDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
				}
				this.$http.post('/admin/index.php/admin/advert/advertList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.avatar-uploader {
		display: flex;
		/* justify-content: center; */
	}

	.avatar-uploader>.ant-upload {
		width: 44.375rem;
		height: 21.875rem;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
